// components/MeetMeSection/MeetMeSection.jsx
import React, { useEffect, useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { motion } from 'framer-motion';
import { API_BASE } from '../config/api';
import './css/MeetMeSection.css';

import FirstImg from './images/3.jpg';
import SecondImg from './images/4.jpg';
import ThirdImg from './images/5.jpg';

const MeetMeSection = () => {
  const defaultMeetme = useMemo(
    () => ({
      subtitle_text: 'من أنا؟',
      title_text: 'رسالتي هي اختصار الطريق عليكِ، وحمايتك من الأخطاء المنهجية.',
      button_text: 'اقرأ قصتي الكاملة',
      image1_url: null,
      image2_url: null,
      image3_url: null,
    }),
    []
  );

  const [meetme, setMeetme] = useState(defaultMeetme);

  const toAbsoluteImageUrl = (maybeUrl) => {
    if (!maybeUrl) return '';
    const u = String(maybeUrl).trim();
    if (!u) return '';
    // If DB stores absolute URL, keep it.
    if (u.startsWith('http://') || u.startsWith('https://')) return u;
    // DB stores relative URLs like "/uploads/meetme/.."
    // Prefix with API_BASE so the image loads from the backend server.
    return `${API_BASE}${u}`;
  };

  useEffect(() => {
    let mounted = true;
    axios
      .get(`${API_BASE}/api/meetme`)
      .then((res) => {
        const data = res.data?.meetme;
        if (!mounted) return;
        setMeetme(data ? { ...defaultMeetme, ...data } : defaultMeetme);
      })
      .catch((err) => {
        console.error('Failed to load meetme section:', err);
        if (!mounted) return;
        setMeetme(defaultMeetme);
      });

    return () => {
      mounted = false;
    };
  }, [defaultMeetme]);

  const img1 = meetme.image1_url ? toAbsoluteImageUrl(meetme.image1_url) : FirstImg;
  const img2 = meetme.image2_url ? toAbsoluteImageUrl(meetme.image2_url) : SecondImg;
  const img3 = meetme.image3_url ? toAbsoluteImageUrl(meetme.image3_url) : ThirdImg;

  return (
    <section className="meet-me-section" dir="rtl">
      <div className="container">
        
        {/* Top Content Row */}
        <div className="row align-items-end mb-5">
          <div className="col-lg-8 col-md-12">
            <motion.div 
              initial={{ opacity: 0, x: 20 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6 }}
            >
              <h4 className="section-subtitle">{meetme.subtitle_text}</h4>
              <h2 className="section-title">{meetme.title_text}</h2>
            </motion.div>
          </div>
          
          <div className="col-lg-4 col-md-12 text-lg-start mt-4 mt-lg-0">
            <Link to="/about" className="btn-story-link">
              <motion.span
                className="btn-story"
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.6, delay: 0.2 }}
              >
                {meetme.button_text}
              </motion.span>
            </Link>
          </div>
        </div>

        {/* Images Row */}
        <div className="row g-4">
          <div className="col-md-4 col-sm-12">
            <motion.div 
              className="image-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.1 }}
            >
              <img 
                src={img1} 
                alt="Academic Focus" 
              />
            </motion.div>
          </div>
          
          <div className="col-md-4 col-sm-12">
            <motion.div 
              className="image-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.3 }}
            >
              <img 
                src={img2} 
                alt="Portrait" 
              />
            </motion.div>
          </div>
          
          <div className="col-md-4 col-sm-12">
            <motion.div 
              className="image-card"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: 0.5 }}
            >
              <img 
                src={img3} 
                alt="Books and Plants" 
              />
            </motion.div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default MeetMeSection;